import { Badge } from "../common/Badge";
import { useFeatureTheme } from "../../context/FeatureThemeContext";

export function ThemeBadge() {
  const { theme } = useFeatureTheme();
  return <Badge tone={theme === "Basic" ? "neutral" : "honey"}>{theme}</Badge>;
}
